import Container from '../Container';
import Heading from '../Heading';
import Form from './Form';
import styles from './styles.module.css'

const GetinTouch = () => {
    return (
        <section className='bg-white py-5'>
            <Container className="py-0 py-xl-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-xxl-11">
                        <div className={styles['primary-grey-bg']}>
                            <div className="row">
                                <div className="col-12 col-lg-5">
                                    <div className="me-0 me-xl-5 pe-0 pe-xl-5">
                                        <div className='mb-5'>
                                            <Heading 
                                                heading="Get in Touch"
                                            />
                                        </div>
                                        <p>We’re open from 7am to 7pm (AEST) Monday to Friday, so if there’s anything you need, just pick up the phone and we’ll be there to help: 
                                            <a href="#" title="{{custom:phone}}">00000000</a>
                                        </p>
                                        <p>Otherwise, fill in the form and we’ll get back to you as soon as we can.</p>									
                                    </div>							
                                </div>

                                <div className="col-12 col-lg-7 mt-3 mt-lg-0">
                                    <Form />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default GetinTouch;